export function groupConsecutive(items, keyOf) {
    const groups = [];
    for (const item of items) {
        const key = keyOf(item);
        const last = groups[groups.length - 1];
        if (last && last.key === key) {
            last.items.push(item);
            last.count++;
        }
        else {
            groups.push({ key, items: [item], head: item, count: 1 });
        }
    }
    return groups;
}
//# sourceMappingURL=group-consecutive.js.map